import { useMemo } from "react";
import FilterMultiSelectBox from "./filterMultiSelectBox";
import { useRoleFilter } from "../filters/useRoleFilter";

const FilterRole = ({
  talentFilter,
  talentFilterTags,
  eventRoles,
  onAddFilter,
}) => {

  const rolesList = useMemo(() => [
    {
      label: "Experiental",
      options:
        eventRoles?.experiential?.event_roles?.map(val => ({
          label: val.name,
          value: val.uuid,
        })) || [],
    },
    {
      label: "Hospitality",
      options:
        eventRoles?.hospitality?.event_roles?.map(val => ({
          label: val.name,
          value: val.uuid,
        })) || [],
    },
    {
      label: "Security",
      options:
        eventRoles?.security?.event_roles?.map(val => ({
          label: val.name,
          value: val.uuid,
        })) || [],
    },
  ], [eventRoles]);

  const {
    selectedRoles,
    setSelectedRoles,
    buildRoleFilter,
  } = useRoleFilter(talentFilter, talentFilterTags, rolesList);

  const handleAdd = () => {
    const payload = buildRoleFilter();
    if (!payload) return;

    onAddFilter("roles", payload);
  };

  return (
    <FilterMultiSelectBox
      title="ROLE (Select one or several)"
      label="Select role or search"
      list={rolesList}
      selectedValue={selectedRoles}
      onChange={setSelectedRoles}
      onAddFilter={handleAdd}
      type="roles"
    />
  );
};

export default FilterRole;
